"use client";

import React from "react";
import { NavHeaderTheme } from "./types";

interface CenterContentProps {
  showLogo?: boolean;
  showTitle?: boolean;
  title?: string;
  logo?: React.ReactNode;
  theme?: NavHeaderTheme;
  TypographyEl?: React.ComponentType<{
    as?: React.ElementType;
    className?: string;
    style?: React.CSSProperties;
    children: React.ReactNode;
  }>;
}

export const CenterContent: React.FC<CenterContentProps> = ({
  showLogo,
  showTitle,
  title,
  logo,
  theme,
  TypographyEl,
}) => {
  // Use theme text class or default
  const textClass =
    theme?.text || "text-current text-base font-normal text-center";

  // Composition-based rendering
  const content: React.ReactNode[] = [];

  if (showLogo && logo) {
    content.push(
      <div key="logo" className="flex items-center">
        {logo}
      </div>
    );
  }

  if (showTitle && title) {
    const TitleComponent = TypographyEl || "h2";
    content.push(
      <TitleComponent
        key="title"
        as="h2"
        className={`flex-grow ${textClass}`.trim()}
      >
        {title}
      </TitleComponent>
    );
  }

  // Handle empty state
  if (content.length === 0) {
    return null;
  }

  // Return content - parent handles centering
  return <div className="flex items-center gap-2">{content}</div>;
};
